<script>
export default {
    name: 'Quiz',

    props: {
        categories: {
            type: Array,
            required: true,
        },

        totalSteps: {
            type: Number,
            required: true,
        },
    },

    data() {
        return {
            step: 1,
            likes: {},
            result: null,
        };
    },

    mounted() {
        this.categories.forEach((category) => {
            this.likes = {
                ...this.likes,
                [category.id]: 0,
            };
        });
    },

    methods: {
        like(data) {
            this.likes[data.category] = this.likes[data.category] + data.score;

            if (this.step < this.totalSteps) {
                this.step = this.step + 1;
                return;
            }

            this.result = this.getResult();
        },

        skip() {
            if (this.step < this.totalSteps) {
                this.step = this.step + 1;
                return;
            }

            this.result = this.getResult();
        },

        getResult() {
            const sorted = Object.keys(this.likes).sort((a, b) => {
                return this.likes[a] - this.likes[b];
            }).reverse();

            const result = this.categories.filter((category) => {
                return category.id === parseInt(sorted[0]);
            });

            return result[0];
        },
    },

    render() {
        return this.$slots.default({
            step: this.step,
            result: this.result,
            like: this.like,
            skip: this.skip,
        });
    },
};
</script>
